import { render, staticRenderFns } from "./UploadFileImg.vue?vue&type=template&id=a12dee24&scoped=true"
import script from "./UploadFileImg.vue?vue&type=script&lang=js"
export * from "./UploadFileImg.vue?vue&type=script&lang=js"
import style0 from "./UploadFileImg.vue?vue&type=style&index=0&id=a12dee24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12dee24",
  null
  
)

export default component.exports